var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// @ts-ignore
import React from "react";
// @ts-ignore
import SvgIcon from "@mui/material/SvgIcon";
var ImageIcon = function (props) { return (React.createElement(SvgIcon, __assign({}, props),
    React.createElement("path", { d: "M20 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16Zm-4.604 7.061a.3.3 0 0 0-.406.039l-6.94 7.475a.261.261 0 0 0-.05.153c0 .15.13.272.289.272H18.71a.301.301 0 0 0 .159-.045.263.263 0 0 0 .083-.376l-3.499-7.456a.278.278 0 0 0-.058-.062ZM7.6 6a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2Z", fill: "currentColor", "fill-rule": "evenodd", "fill-opacity": ".86" }))); };
export default ImageIcon;
